import React from "react";
import PropTypes from "prop-types";
import { formatTime } from "../Misc/Utils";
import CheckIcon from "../Misc/Icons/CheckIcon";

var ScriptInfo = function ScriptInfo(_ref) {
  var script = _ref.script,
      title = _ref.title,
      isTeleprompterHidden = _ref.isTeleprompterHidden,
      edit = _ref.edit,
      toggleTeleprompter = _ref.toggleTeleprompter;
  var scriptWordsCount = script.split(" ").length;
  return React.createElement("div", {
    className: "recorder__info"
  }, React.createElement("div", {
    className: "recorder__info-title"
  }, title), React.createElement("div", {
    className: "recorder__info-duration"
  }, "Estimated length: ", formatTime(scriptWordsCount / 3)), React.createElement("div", {
    className: "recorder__info-extra"
  }, React.createElement("label", {
    className: "check check--size-m check--color-java check--style-label"
  }, React.createElement("input", {
    type: "checkbox",
    className: "check__helper",
    checked: isTeleprompterHidden,
    onChange: function onChange() {
      return toggleTeleprompter();
    }
  }), React.createElement("span", {
    className: "check__icon"
  }, React.createElement(CheckIcon, null)), React.createElement("span", {
    className: "check__label"
  }, "Record video without script")), React.createElement("button", {
    className: "button button--reset button--link",
    onClick: function onClick() {
      return edit();
    }
  }, "Edit")));
};

ScriptInfo.propTypes = process.env.NODE_ENV !== "production" ? {
  script: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isTeleprompterHidden: PropTypes.bool,
  toggleTeleprompter: PropTypes.func,
  edit: PropTypes.func.isRequired
} : {};
export default ScriptInfo;